import Vue from 'vue'
import Router from 'vue-router'
import MainLayout from '@/pages/layout/MainLayout'
import NoticeLayout from '@/pages/layout/NoticeLayout'
import MiddleLayout from '@/pages/layout/MiddleLayout'

import Index from '@/pages/Index'
import Search from '@/pages/Search'
import Notice from '@/pages/index/Notice'
import NoticeDetail from '@/pages/index/NoticeDetail'
import NoticeIntro from '@/pages/index/NoticeIntro'
import Relative from '@/pages/index/Relative'
import One from '@/pages/index/One'
import Download from '@/pages/index/Download'
import Video from '@/components/Video'

//学历
import EduLayout from '@/pages/layout/EduLayout'
import Dis from '@/pages/edu/Dis'
import Enroll from '@/pages/edu/Enroll'
import TeachPoint from '@/pages/edu/TeachPoint'
import EduNotice from '@/pages/edu/Notice'
import EduNoticeIntro from '@/pages/edu/NoticeIntro'

//非学历
import TrainLayout from '@/pages/layout/TrainLayout'
import TrainIndex from '@/pages/train/Index'


Vue.use(Router)
const router = new Router({
	mode: 'history',
	//base: '/jm',
	routes: [
		{
			path: '/Video',
			name: 'Video',
			component: Video,
			// meta:{
			//   keepalive:true
			// }
		  },
		{
			path: '/',
			component: MainLayout,
			redirect: '/index',
			children: [
				{
					path: 'index',
					component: Index,
					meta: {title: '浙江经贸职业技术学院继续教育学院'}
				},
				{
					path: 'news',
					component: MiddleLayout,
					children: [
						{
							path: '',
							component: NoticeLayout,
							children: [
								{
									name: 'news_list',
									path: ':id(\\d+)',
									component: Notice,
								},
								{
									name: 'news_detail',
									path: 'detail/:id(\\d+)',
									component: NoticeIntro
								},
								{
									name: 'index_relative',
									path: 'relative/:id(\\d+)',
									component: Relative
								},
								{
									name: 'one_news_detail',
									path: 'one/:id(\\d+)',
									component: One
								},
								{
									name: 'index_download',
									path: 'download/:id(\\d+)',
									component: Download
								},
							]
						},
						
						{
							name: 'news_sdetail',
							path: 'sdetail/:id(\\d+)',
							component: NoticeDetail 
						},
					]
				},
				{
					path: 'edu',
					component: MiddleLayout,
					children: [
						{
							path: '',
							component: EduLayout,
							redirect: 'dis/1',
							children: [
								{
									name: 'edu_dis_list',
									path: 'dis/:id(\\d+)/',
									component: Dis,
								},
								{
									name: 'edu_enroll_list',
									path: 'enroll/:id(\\d+)/',
									component: Enroll,
								},
								{
									name: 'edu_news',
									path: 'news/:id(\\d+)/',
									component: EduNotice,
								},
								{
									name: 'teach_point',
									path: 'teach-point/:id(\\d+)/',
									component: TeachPoint,
								},
								{
									name: 'edu_detail',
									path: 'detail/:id(\\d+)/',
									component: EduNoticeIntro,
								},
								
							]
						},
						
						
					]
				},
				{
					path: 'train',
					component: MiddleLayout,
					redirect: 'index',
					children: [
						{
							name: 'train_index',
							path: '',
							component: TrainIndex,
						},
						{
							name: 'train_index',
							path: 'index',
							component: TrainIndex,
						},
						{
							path: '',
							component: TrainLayout,
							children: [
								{
									name: 'train_news_list',
									path: 'news/:id(\\d+)/',
									component: Notice,
								},
								{
									name: 'train_news_detail',
									path: 'detail/:id(\\d+)/',
									component: NoticeIntro,
								},
							]
						},
						
						
					]
				},
				{
					path: 'search',
					component: Search,
				}
			]
		}
	]
})
router.beforeEach((to, from, next) => {
	// if(to.meta && to.meta.title)
	// 	document.title = to.meta.title
	document.title = '浙江经贸职业技术学院继续教育学院'
	next()
})
export default router
